import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Home from './views/Home.vue'
import Detail from './views/Detail.vue'
import Debug from './views/Debug.vue'
import Animation from './views/Animation.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },

    {
      path: '/north',
      beforeEnter (to, from, next) {
        store.dispatch('settings/setLocation', 'north')
        next('/')
      }
    },

    {
      path: '/south',
      beforeEnter (to, from, next) {
        store.dispatch('settings/setLocation', 'south')
        next('/')
      }
    },

    {
      path: '/debug',
      name: 'debug',
      component: Debug
    },

    {
      path: '/animation',
      name: 'animation',
      component: Animation
    },
    {
      path: '/:slug',
      name: 'homeMenu',
      component: Home
    },
    {
      path: '/*',
      name: 'detail',
      component: Detail
    }
  ],

  mode: 'history',
  base: process.env.BASE_URL
})

export default router
